import { useRef } from "react";
import { NotebookPen } from "lucide-react";

import { IconPill } from "../Universal/IconPill";
import { usePanels } from "../contexts/PanelsContext";

const PopUpNotes = ({ buttonNavbar = false, iconOnly = false }) => {
  const { isNotesOpen, setIsNotesOpen } = usePanels();
  const overlayRef = useRef(null);

  const toggleNotes = () => {
    setIsNotesOpen(!isNotesOpen);
  };

  const iconBtnClasses = [
    "flex items-center justify-center w-8 h-8 rounded-lg",
    "border border-transparent bg-transparent",
    "text-mutedText transition hover:bg-mainButtonBg/50 hover:text-mainText",
    "outline-none ring-inputFocus/60 focus-visible:ring-2",
    "cursor-pointer",
  ].join(" ");

  const iconClass = [
    "transition-colors duration-200",
    isNotesOpen ? "text-velBlue" : "text-mutedText/60",
  ].join(" ");

  const renderButton = () => {
    if (iconOnly) {
      return (
        <button
          type="button"
          onClick={toggleNotes}
          className={iconBtnClasses}
          aria-label={isNotesOpen ? "Close notes" : "Open notes"}
          aria-expanded={isNotesOpen}
          title="Notes"
        >
          <NotebookPen
            strokeWidth={1.5}
            className={["h-[18px] w-[18px]", iconClass].join(" ")}
          />
        </button>
      );
    }

    if (buttonNavbar) {
      return (
        <IconPill size="md" onClick={toggleNotes} aria-label="Open notes">
          <NotebookPen
            strokeWidth={1}
            className={["h-5 w-5 shrink-0", iconClass].join(" ")}
          />
        </IconPill>
      );
    }

    return (
      <button
        type="button"
        onClick={toggleNotes}
        aria-label={isNotesOpen ? "Close notes" : "Open notes"}
        aria-expanded={isNotesOpen}
        className={[
          "relative group w-full rounded-lg border px-4 py-2 transition-all duration-200 cursor-pointer",
          isNotesOpen
            ? "bg-velBlue/15 border-velBlue/30"
            : "bg-transparent border-surfaceBorder hover:bg-btnHover hover:border-velBlueSecond/25",
        ].join(" ")}
      >
        <div className="relative z-10 flex items-center gap-x-3 min-h-[32px]">
          <NotebookPen
            strokeWidth={1}
            className={["h-5 w-5 shrink-0", iconClass].join(" ")}
          />
          <span
            className={[
              "truncate text-[15px] font-normal tracking-wide",
              isNotesOpen ? "text-velBlue" : "text-mutedText",
            ].join(" ")}
          >
            Notes
          </span>
        </div>
      </button>
    );
  };

  return (
    <div className="relative inline-block text-left text-base" ref={overlayRef}>
      {renderButton()}
    </div>
  );
};

export default PopUpNotes;
